// Copyright (c) 2017 Deere & Company

import LaborRate from '@deere/cps-it.warranty-model-factory/lib/labor-rate';
import actions from '../../action-list';
import {getDefaultState} from '../state';

const setLaborRates = (state, action) =>
    LaborRate.update(state, {
        $set: action.data
    });

const updateRequestedRate = (state, action) =>
    LaborRate.update(state, {
        rates: {
            [action.index]: {
                requestedRate: {
                    $set: action.rate
                }
            }
        }
    });

const updateComment = (state, action) =>
    LaborRate.update(state, {
        rates: {
            [action.index]: {
                reasonForChange: {
                    $set: action.comment
                }
            }
        }
    });

const updateEffectiveDate = (state, action) =>
    LaborRate.update(state, {
        effectiveDate: {
            $set: action.effectiveDate
        }
    });

const updateFile = (state, action) =>
    LaborRate.update(state, {
        file: {
            $set: action.file
        }
    });

const updateAverageTechPayRate = (state, action) =>
    LaborRate.update(state, {
        averageTechPayRate: {
            $set: action.rate
        }
    });

export default (state = getDefaultState().laborRate, action) => {

    const actionTypes = {
        [actions.UPDATE_LABOR_RATE_CHANGE_RATES]: setLaborRates,
        [actions.UPDATE_LABOR_RATE_REQUESTED_RATE]: updateRequestedRate,
        [actions.UPDATE_LABOR_RATE_COMMENT]: updateComment,
        [actions.UPDATE_LABOR_RATE_EFFECTIVE_DATE]: updateEffectiveDate,
        [actions.UPDATE_LABOR_RATE_FILE]: updateFile,
        [actions.UPDATE_LABOR_RATE_AVERAGE_TECH_PAY_RATE]: updateAverageTechPayRate
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/labor-rate-change/reducers/labor-rate.js